import { ContributorType } from "@/src/types";
import { Card, CardBody, Typography } from "@material-tailwind/react";
import Link from "next/link";
import ContributorSocials from "../contributor/socials";
import Image from "next/image";

export interface SmallContributorCardProps {
  contributor: ContributorType;
  hasElevation?: boolean;
  transparent?: boolean;
}

const SmallContributorCard = ({
  contributor,
  hasElevation = true,
  transparent = false,
}: SmallContributorCardProps) => {
  return (
    <div className={"small-contributor-card"}>
      <Card
        style={{ flex: "1 1 0px", borderRadius: 0 }}
        shadow={hasElevation}
        color={transparent ? "transparent" : "white"}
      >
        <CardBody className="p-0">
          <div className={"flex flex-row h-[100%]"}>
            <Link href={contributor.uri}>
              <div className="image w-[100px] h-[120px] relative rounded">
                <Image
                  src={contributor?.contributormeta?.image?.node?.mediaItemUrl}
                  alt={`${contributor?.name} profile picture`}
                  fill
                  className="rounded"
                />
              </div>
            </Link>

            <div className={"p-4 flex gap-1 flex-col text-container h-[120px]"}>
              <Link href={contributor.uri}>
                <Typography
                  variant="paragraph"
                  className={"text-black text-xl font-bold"}
                >
                  {contributor?.name}
                </Typography>
                <Typography variant="paragraph" className="text-black text-sm">
                  {contributor.contributormeta.oneLineBio}
                </Typography>
              </Link>
              <ContributorSocials contributor={contributor} />
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default SmallContributorCard;
